/**
 * A useful hook for reading notifications and for clearing current notifications.
 *
 * Uses [[useTranslation]] hook to translate the notification.
 *
 * - If a `notification_key` has been set in Cookies, this hook will return it as `notification`. Once a `notification_key` has been retrieved from Cookies, it is then cleared automatically.
 *
 * - Call `clearNotification` at any time to remove any notification from state.
 *
 * `useNotifications` was designed to be used with the `Alert` Elevio component.
 *
 * @module
 */
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
// import { useQueryParam, StringParam } from 'use-query-params';
import { useTranslation } from './useTranslation';
import { NOTIFICATION_KEY } from '../utils/config';
function errorWithCode(t, errorCode, notificationKey) {
    return t('notification.loginError', 'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})', { notificationKey, errorCode });
}
export const getNotification = (notificationKey, t) => {
    let message;
    let type;
    switch (notificationKey) {
        // case 'MissingAuthTokenError':
        //   message = t(
        //     'notification.missingAuthTokenError',
        //     'Sorry, there was a problem with your login.'
        //   );
        //   type = 'error';
        //   break;
        case 'TokenExpiredError':
            message = errorWithCode(t, 'S1', notificationKey);
            type = 'error';
            break;
        // case 'NotBeforeError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S2' }
        //   );
        //   type = 'error';
        //   break;
        // ? needed now?
        // MissingHash
        // InvalidHash
        // case 'JsonWebTokenError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S3' }
        //   );
        //   type = 'error';
        //   break;
        // case 'DataIncompleteError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S5' }
        //   );
        //   type = 'error';
        //   break;
        case 'LoggedIn':
            message = t('notification.loggedIn', 'Logged in.');
            type = 'success';
            break;
        case 'LoggedOut':
            message = t('notification.loggedOut', 'Logged out.');
            type = 'success';
            break;
        // case 'GetUserTokenError':
        // case 'SignTokenError':
        // case 'VerifyTokenError':
        default:
            message = t('notification.generalError', 'Sorry something went wrong, please try again. \n({{notificationKey}})', { notificationKey });
            type = 'error';
    }
    return { message, type };
};
/**
 *
 * # useNotification
 *
 * Example usage:
 * ```javascript
 * import useNotifications from '@elevio/kb-kit/lib/hooks';
 *
 * const MyNotificationExample = () => {
 *   const { notification, clearNotification } = useNotifications();
 *   console.log(notification); // Notification | undefined
 *   console.log(clearNotification); // () => void
 *
 *   return (
 *     <div>
 *       <span>
 *           {notification?.message ? notification.message : 'No notifications at present'}
 *       </span>
 *       <button
 *
 *         onClick={clearNotification}
 *       >
 *         Clear notification
 *       </button>
 *     </div>
 *   )
 * };
 * ```
 */
export function useNotifications() {
    const { t } = useTranslation();
    const notificationParamKey = Cookies.get(NOTIFICATION_KEY);
    const [notificationKey, setNotificationKey] = useState(notificationParamKey);
    // Now remove it as it's not required on refresh.
    useEffect(() => {
        Cookies.remove(NOTIFICATION_KEY);
    }, []);
    const clearNotification = () => {
        setNotificationKey(undefined);
    };
    let notification;
    if (notificationKey) {
        notification = getNotification(notificationKey, t);
    }
    return {
        notification,
        clearNotification,
    };
}
//# sourceMappingURL=useNotifications.js.map